import { miniTable } from "MODULES/shared/decorators";
import api from "APP_ROOT/api";
import { CREATED_AT } from "APP_ROOT/constants";
import { withRouter } from "react-router";
import withSubscription from "MODULES/Subscription/withSubscription";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { shortDateYY } from "LIB/formatters/date";
import {
  CompanyName,
  DataTable,
  NoteTooltipTableCell
} from "MODULES/shared/components";
import { getFirstNameLastInitial } from "LIB/formatters/text";
import LineItemStatusCell from "MODULES/RepairQuotes/styles";
import {
  AVG_OVERHAUL,
  AVG_REPAIR,
  AVG_TEST,
  BER_RATE,
  EVALUATION_FEE,
  QUOTE_TYPES_ABBREV,
  TURNAROUND_TIME
} from "MODULES/RepairQuotes/constants";
import { RenderQuoteField } from "MODULES/parts/components/RepairQuoteLineItems/Table";
import { percentFormatter } from "MODULES/shared/components/StatsTooltip/format";

export class LineItemsTable extends Component {
  static propTypes = {
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        incoming_quote_id: PropTypes.number.isRequired,
        quote_type: PropTypes.string.isRequired,
        condition: PropTypes.string,
        company_name: PropTypes.string,
        legacy_company_name: PropTypes.string,
        cost: PropTypes.string
      })
    ).isRequired,
    setActiveRepairQuote: PropTypes.func,
    loading: PropTypes.bool.isRequired
  };

  renderRow = (lineItem, i) => (
    <tr
      key={lineItem.id}
      className="clickable"
      onClick={() => this.props.setActiveRepairQuote(lineItem)}
    >
      <td>
        <div style={{ whiteSpace: "nowrap" }}>{i + 1}</div>
      </td>
      <LineItemStatusCell lineItem={lineItem}>
        <span
          className={
            lineItem.updated_at !== lineItem.created_at && "text-yellow"
          }
        >
          {shortDateYY(lineItem.updated_at || lineItem.created_at)}
        </span>
      </LineItemStatusCell>
      <td className="text-nowrap">
        <CompanyName flattenedCompany={lineItem} truncateAt={14} />
      </td>
      <td className="text-nowrap">
        {lineItem.created_by &&
          getFirstNameLastInitial(lineItem.created_by.full_name)}
      </td>
      <td>{QUOTE_TYPES_ABBREV[lineItem.quote_type]}</td>
      <RenderQuoteField lineItem={lineItem} field={AVG_OVERHAUL} />
      <RenderQuoteField lineItem={lineItem} field={AVG_REPAIR} />
      <RenderQuoteField lineItem={lineItem} field={AVG_TEST} />
      <RenderQuoteField lineItem={lineItem} field={TURNAROUND_TIME} />
      <RenderQuoteField lineItem={lineItem} field={EVALUATION_FEE} />
      <RenderQuoteField
        lineItem={lineItem}
        field={BER_RATE}
        formatter={f => f && percentFormatter(f)}
      />
      <NoteTooltipTableCell note={lineItem.notes} />
    </tr>
  );

  render() {
    const { results } = this.props;
    return (
      <DataTable.Mini loading={this.props.loading} numbered>
        <DataTable.Head>
          <th />
          <th>Date</th>
          <th>Repair Station</th>
          <th>Created By</th>
          <th>Type</th>
          <th className="text-right">Avg OH</th>
          <th className="text-right">Avg SV</th>
          <th className="text-right">Avg BT</th>
          <th className="text-right">TAT</th>
          <th className="text-right">Eval Fee</th>
          <th className="text-right">BER %</th>
          <th />
        </DataTable.Head>
        <DataTable.Body>{results.map(this.renderRow)}</DataTable.Body>
      </DataTable.Mini>
    );
  }
}

const withResults = miniTable(({ match }, params) =>
  api.parts.repairQuoteLineItems.search(
    match.params.id,
    Object.assign(params, { sort: CREATED_AT })
  )
);

export default withRouter(
  withResults(withSubscription("RepairQuoteLineItem")(LineItemsTable))
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/RepairQuotes/LineItemsTable.jsx